export const getRootBounsesLink = () => {
  /* This is duplicated in the routes in app.js */
  return '/bonuses';
};


export const getBonusesLink = (ticketId, bonusMonth, showProcessed) => {
  const rootLink = getRootBounsesLink();
  const url = `${rootLink}/?ticketId=${ticketId}&bonusMonth=${bonusMonth}&showProcessed=${showProcessed}`;
  return url;
};
